export default __webpack_public_path__ + "static/grenette-italic-pro-be52230b912ef06b947afb17ece39710.ttf";